<template>
    <div v-if="!icon">
        <div v-if="current != null" @click="viewForecast = !viewForecast">
            <table style="padding:4px 0px 0px 0px" class="main_table" >
                <tr v-if="!hideDateTime">
                    <td colspan="4" style="text-align:center; border-bottom:2px solid black; padding:4px">
                        <span style="font-size:40px">{{current.dateTime.month_2d}}月{{current.dateTime.day_2d}}日</span>
                        <span style="font-size:24px; margin-left:8px">{{current.dateTime.hour12_2d}}:{{current.dateTime.minute_2d}}</span>
                        <span style="font-size:16px; margin-left:4px">{{current.dateTime.amPm}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <img :src="current.weather.icon" crossorigin="Anonymous" style="width:128px; height:128px" />
                    </td>
                    <td style="padding-right:4px">
                        <table>
                            <tr>
                                <td>
                                    <table v-if="!hideTemp">
                                        <tr>
                                            <td style="text-align:center">
                                                <span style="font-size:45px">{{current.environment.temp.toFixed(1)}}</span><span style="font-size:20px">℃</span>
                                            </td>
                                            <td>
                                                <div v-if="!hideTempMin"><span style="font-size:14px; margin-left:4px">{{current.environment.temp_min.toFixed(1)}}</span><span style="font-size:10px">℃</span></div>
                                                <div v-if="!hideTempMax"><span style="font-size:14px; margin-left:4px">{{current.environment.temp_max.toFixed(1)}}</span><span style="font-size:10px">℃</span></div>
                                            </td>
                                        </tr>
                                    </table>                                    
                                </td>
                            </tr>
                            <tr v-if="!hideHumid"><td style="white-space:nowrap"><span style="font-size:16px">湿度:{{current.environment.humidity}}</span><span style="font-size:10px">%</span></td><tr>
                            <tr v-if="!hidePressure"><td style="white-space:nowrap"><span style="font-size:16px">気圧:{{current.environment.pressure}}</span><span style="font-size:10px">hPa</span></td></tr>
                        </table> 
                    </td>
                    <td v-if="viewForecast" style="border-left:solid 2px; padding:0px 8px 0px 8px">
                        <table>
                            <tr>
                                <td style="text-align:center" :colspan="forecasts.length">3時間ごとの予報</td>
                            </tr>
                            <tr>
                                <td v-for="(forecast, index) in forecasts" :key="index" style="text-align:center" class="forecast_table">
                                    {{forecast.dateTime.hour24_2d}}:{{forecast.dateTime.minute_2d}}<br/>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="forecast.weather.icon" crossorigin="Anonymous" style="width:32px; height:32px" />
                                            </td>
                                            <td>
                                                <span style="font-size:14px; margin-left:4px">{{forecast.environment.temp_min.toFixed(0)}}</span><span style="font-size:10px">℃</span><br/>
                                                <span style="font-size:14px; margin-left:4px">{{forecast.environment.temp_max.toFixed(0)}}</span><span style="font-size:10px">℃</span>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div v-else>
        <div style="position:relative; width:32px; height:32px">
            <div v-if="enableToolTip && viewIconToolTip" class="icon_balloon" :style="styleToolTipPosition">
                {{current.dateTime.month_2d}}月{{current.dateTime.day_2d}}日 - {{current.environment.temp.toFixed(1)}}℃
            </div>
            <img :src="current.weather.icon" crossorigin="Anonymous" style="width:100%; height:100%" @mouseover="viewIconToolTip=true" @mouseout="viewIconToolTip=false"/>            
        </div>
    </div>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    /**
     * 日時を表すクラス
     */
    class DateTime {
        /**
         * コンストラクタ
         */
        constructor (date) {
            if (date != null) {
                this.refresh(date)
            } else {
                this.refresh(new Date())
            }
        }
        /**
         * プロパティを更新します。
         */
        refresh (date) {
            const hour = date.getHours()
            this.year = date.getFullYear()
            this.month = date.getMonth() + 1
            this.day = date.getDate()
            this.hour24 = hour
            this.hour12 = hour - (hour >= 12 ? 12 : 0)
            this.minute = date.getMinutes()
            this.second = date.getSeconds()
            this.amPm = (hour < 12 ? "AM" : "PM")
            this.month_2d = ("0"+this.month).slice(-2)
            this.day_2d = ("0"+this.day).slice(-2)
            this.hour24_2d = ("0"+this.hour24).slice(-2)
            this.hour12_2d = ("0"+this.hour12).slice(-2)
            this.minute_2d = ("0"+this.minute).slice(-2)
            this.second_2d = ("0"+this.second).slice(-2)
            this.raw = date
        }
    }

    import Axios from "axios"

    export default {
        props: {
            icon: {
                type: Boolean,
                default: false
            },
            hideDateTime: {
                type: Boolean,
                default: false
            },
            hideTemp: {
                type: Boolean,
                default: false
            },
            hideTempMax: {
                type: Boolean,
                default: false
            },
            hideTempMin: {
                type: Boolean,
                default: false
            },
            hideHumid: {
                type: Boolean,
                default: false
            },
            hidePressure: {
                type: Boolean,
                default: false
            },
            enableToolTip: {
                type: Boolean,
                default: true
            },
            toolTipPosition: {
                type: String,
                default: "top"
            }
        },
        computed: {
            styleToolTipPosition: function () {
                switch (this.toolTipPosition) {
                    case "top": return "margin-top:-24px;"
                    case "bottom": return "margin-top:30px;"
                }
            }
        },
        data: function () {
            return {
                current: null,
                forecasts: [],
                viewForecast: false,
                viewIconToolTip: false
            }
        },
        mounted: function () {
            this.refresh()
        },
        methods: {
            onIconMouseOver: function () {
                console.log("onIconMouseOver")
            },
            refresh: function () {
                const self = this
                const requestWeatherURL = "https://api.openweathermap.org/data/2.5/weather?q=Kurume,jp&units=metric&lang=ja&appid="+"1ebb8abc21c4dbb98dc6080d5680c1ad"
                Axios.get(requestWeatherURL).then(function(result){
                    console.log("weather", result)
                    if (result.status == 200) {
                        self.current = {
                            dateTime: new DateTime(),
                            weather: {
                                state: result.data.weather[0].main,
                                icon: "http://openweathermap.org/img/wn/"+result.data.weather[0].icon+"@2x.png",
                                description: result.data.weather[0].description
                            },
                            environment: {
                                temp: result.data.main.temp,
                                temp_min: result.data.main.temp_min,
                                temp_max: result.data.main.temp_max,
                                humidity: result.data.main.humidity,
                                pressure: result.data.main.pressure,
                            },
                            wind: {
                                deg: result.data.wind.deg,
                                speed: result.data.wind.speed
                            },
                        }
                    }
                }).catch (function(error) {
                    console.log(error)
                })

                const requestForecastURL = "https://api.openweathermap.org/data/2.5/forecast?q=Kurume,jp&units=metric&lang=ja&cnt=4&appid="+"1ebb8abc21c4dbb98dc6080d5680c1ad"
                Axios.get(requestForecastURL).then(function(result){
                    console.log("forecast", result)
                    if (result.status == 200) {
                        self.forecasts = []
                        result.data.list.forEach(function (data) {
                            const forecast = {
                                dateTime: new DateTime(self.convertJapaneseTime(data.dt_txt)),
                                weather: {
                                    state: data.weather[0].main,
                                    description: data.weather[0].description,
                                    icon: "http://openweathermap.org/img/wn/"+data.weather[0].icon+"@2x.png"
                                },
                                environment: {
                                    temp: data.main.temp,
                                    temp_min: data.main.temp_min,
                                    temp_max: data.main.temp_max,
                                    humidity: data.main.humidity,
                                    pressure: data.main.pressure,
                                },
                                wind: {
                                    deg: data.wind.deg,
                                    speed: data.wind.speed
                                }
                            }
                            self.forecasts.push(forecast)
                        })
                    }
                }).catch (function(error) {
                    console.log(error)
                })

                setTimeout(self.refresh, 60000)
            },
            convertJapaneseTime: function (dateTime) {
                const d = new Date(dateTime)
                d.setHours(d.getHours()+9)
                return d
            }
        }
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Abel&display=swap');
    .main_table {
        font-family: Abel;
        border: 2px solid gray;
        border-collapse: separate;
        border-spacing: 0;
        border-radius: 6px;
        overflow: hidden;
    }
    .forecast_table {
        font-family: Abel;
        border: 2px solid #aaaaaa;
        border-collapse: separate;
        border-spacing: 0;
        border-radius: 6px;
        overflow: hidden;
    }
    .icon_balloon {
        position: absolute;
        background-color: yellow;
        font-size: xx-small;
        font-weight: bold;
        border: 2px solid gray;
        border-radius: 4px;
        padding: 4px;
        margin-left: -50px;
        width: 100px;
        box-shadow: 0px 4px 4px 0 rgba(63, 52, 52, 0.2);
    }
</style>
